import { Banner } from "../Banner";
import { Skeleton } from "../Skeleton";

import "./styles.scss";

const SELECTOR_CARD_COUNT = 17;

export const GridModuleSkeleton = () => {
  return (
    <Banner
      small
      light
      customBgColor="neutral-50"
      customClass="banner-preview"
    >
      <div className="grid-module-skeleton__header">
        <Skeleton
          width="60%"
          height="36px"
          className="grid-module-skeleton__title"
        />
        <Skeleton
          width="50%"
          height="24px"
          className="grid-module-skeleton__subtitle"
        />
      </div>

      <div className="grid-module-skeleton__preview">
        <div className="grid-module-skeleton__selector-scroll">
          <div className="grid-module-skeleton__selector-track">
            {[...Array(SELECTOR_CARD_COUNT)].map((_, i) => (
              <div
                className="grid-module-skeleton__selector-card"
                key={i}
              >
                <Skeleton className="grid-module-skeleton__selector-icon" />
                <Skeleton
                  width="100%"
                  height="12px"
                  className="grid-module-skeleton__selector-label"
                />
              </div>
            ))}
          </div>
        </div>

        <Skeleton
          width="100%"
          height="8px"
          className="grid-module-skeleton__selector-scrollbar"
        />

        <div className="grid-module-skeleton__body">
          <div className="grid-module-skeleton__mobile-preview">
            <div className="grid-module-skeleton__mobile-notch" />
            <div className="grid-module-skeleton__mobile-content">
              <Skeleton
                width="80%"
                height="12px"
              />
              <Skeleton
                width="90%"
                height="80px"
                className="grid-module-skeleton__mobile-image"
              />
              <Skeleton
                width="70%"
                height="12px"
              />
              <Skeleton
                width="85%"
                height="80px"
                className="grid-module-skeleton__mobile-image"
              />
            </div>
          </div>

          <div className="grid-module-skeleton__card">
            <Skeleton
              width="100%"
              height="32px"
            />
            <Skeleton
              width="100%"
              height="20px"
            />
            <Skeleton
              width="95%"
              height="20px"
            />
            <Skeleton
              width="90%"
              height="20px"
            />
            <Skeleton
              width="100%"
              height="48px"
              className="grid-module-skeleton__cta-button"
            />
          </div>
        </div>
      </div>
    </Banner>
  );
};
